export function useLocalizedStrings() {
  const localizedStrings = useState<Record<string, string>>(
    'localizedStrings',
    () => ({}),
  )

  const setLocalizedStrings = (strings: Record<string, string>) => {
    localizedStrings.value = {
      ...localizedStrings.value,
      ...strings,
    }
  }

  return {
    localizedStrings,
    setLocalizedStrings,
  }
}
